import { render, staticRenderFns } from "./TyoriSetting.vue?vue&type=template&id=b98b3678&"
import script from "./TyoriSetting.vue?vue&type=script&lang=js&"
export * from "./TyoriSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports